import { useEffect, useState } from 'react';

const DEFAULT_BREAKPOINT = 768;

const getMatches = (breakpoint) => {
  if (typeof window === 'undefined') return false;
  const widthMatches = window.matchMedia(`(max-width: ${breakpoint - 1}px)`).matches;
  const coarsePointer = window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  const ua = window.navigator?.userAgent || '';
  const iOSDevice = /iPhone|iPad|iPod/i.test(ua) ||
    (window.navigator?.platform === 'MacIntel' && window.navigator?.maxTouchPoints > 1);

  return widthMatches || coarsePointer || iOSDevice;
};

export const useIsMobile = (breakpoint = DEFAULT_BREAKPOINT) => {
  const [isMobile, setIsMobile] = useState(() => getMatches(breakpoint));

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const pointerQuery = window.matchMedia('(hover: none) and (pointer: coarse)');
    const handleChange = () => setIsMobile(getMatches(breakpoint));

    setIsMobile(getMatches(breakpoint));
    mediaQuery.addEventListener('change', handleChange);
    pointerQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      pointerQuery.removeEventListener('change', handleChange);
    };
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
